"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _submit = _interopRequireDefault(require("../../../../../core/submit"));
var _rowConfig = _interopRequireDefault(require("../../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../../../core/input-on-blur"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "This will create competition on CanoeSlalomEntries to allow for online entries based on the application");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Slug/URL* (Must be unique in year and cannot be changed)");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Short Name*");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Include Officials");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Generate Races");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Send Setup Email");
var _ref7 = /*#__PURE__*/_react.default.createElement(_submit.default, {
  type: "primary"
}, "Create Competition");
class CreateCompetitionModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      processing: false,
      shortName: null,
      competitionSlug: null,
      includeOfficials: true,
      generateRaces: true,
      sendEmail: true
    });
    _defineProperty(this, "_setValue", (value, field) => {
      this.setState({
        [field]: value
      });
    });
    _defineProperty(this, "_getShortName", () => {
      return (this.state.shortName || this.props.application.site.abbreviation || this.props.application.site.location.substring(0, 13)).replace(/\s/gi, '-');
    });
    _defineProperty(this, "_getCompetitionSlug", () => {
      return this.state.competitionSlug || this.props.application.competitionName.replace(/\s/gi, '-').replace(/\//gi, '-').toLowerCase().substring(0, 100);
    });
    _defineProperty(this, "_validateCompetitionSlug", value => {
      if (this.props.competitions.some(comp => comp.competitionSlug === value && comp.applicationID !== this.props.application.id)) return value + ' already exists - competition slug must be unique.';
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      if (this.state.processing) return;
      this.setState({
        processing: true
      });
      this.props.onCreateCompetition(this.props.application.id, this._getShortName(), this._getCompetitionSlug(), this.state.includeOfficials, this.state.generateRaces, this.state.sendEmail);
      this.props.onToggleCreateCompetition();
    });
  }
  render() {
    const application = this.props.application;
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Create Competition for Entries for ' + application.competitionName,
      onClose: this.props.onToggleCreateCompetition,
      size: "lg"
    }, _ref, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 5,
        md: 4
      }, {
        sm: 7,
        md: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "URL",
      name: "competitionSlug",
      value: this._getCompetitionSlug(),
      onChange: this._setValue,
      maxLength: 100,
      required: true,
      customValidation: this._validateCompetitionSlug
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "shortName",
      value: this._getShortName(),
      onChange: this._setValue,
      maxLength: 15,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "includeOfficials",
      checked: this.state.includeOfficials,
      onChange: this._setValue
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "generateRaces",
      checked: this.state.generateRaces,
      onChange: this._setValue
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "sendEmail",
      checked: this.state.sendEmail,
      onChange: this._setValue
    })))), _ref7, ' ', /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onToggleCreateCompetition
    }, "Cancel")));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CreateCompetitionModal, "partialQueries", {
  Application: {
    id: true,
    competitionName: true,
    calendarID: true,
    site: {
      abbreviation: true,
      location: true
    }
  }
});
var _ref8 = {
  id: true,
  competitionSlug: true,
  applicationID: true
};
var _default = exports.default = (0, _reactBicycle.connect)(CreateCompetitionModal, props => ({
  ["competitions(yearID:" + JSON.stringify(+props.application.calendarID) + ")"]: _ref8
}), (client, props) => ({
  onCreateCompetition(applicationID, shortName, competitionSlug, includeOfficials, generateRaces, sendEmail) {
    return client.update('Competition.createCompetitionFromApplication', {
      applicationID,
      shortName,
      competitionSlug,
      includeOfficials,
      generateRaces,
      sendEmail
    });
  }
}));